// Components==============
import React from 'react';
import { getDate } from 'utilities/getDate';
import { useGraphDays } from 'utilities/useGraphDays';
import './Graph.module.scss';
// =========================

export default function Graph({
    weekGoal,
    data,
    hideOverflow,
}: {
    weekGoal: number;
    data: (GraphDataEntity | undefined)[];
    hideOverflow?: boolean;
}) {
    const allAnswers = data.map((d) =>
        d?.given_answer ? parseInt(d?.given_answer) : NaN
    );

    const sum = allAnswers.reduce((a, b) => a + b, 0);
    const average = Math.round(sum / allAnswers.length);
    const goal = weekGoal || average;
    const highestAnswer = Math.max(...allAnswers);
    const peek = Math.max(highestAnswer, goal);

    const getColumnWidth = () => {
        if (data.length > 12) return 50;
        if (data.length > 9) return 70;

        return 90;
    };

    const sortedData = data.sort(
        (a, b) => getDate(a?.updated_at) - getDate(b?.updated_at)
    );

    const firstItemGetter = new Date(
        sortedData?.[0]?.updated_at || ''
    ).getDay();

    const firstItem = firstItemGetter === 0 ? 7 : firstItemGetter;
    const lastItem = sortedData[data.length - 1];

    const days = useGraphDays(data, firstItem);

    return (
        <div
            styleName="wrapper"
            style={{ maxWidth: data.length > 12 ? 800 : '' }}
        >
            <div
                styleName="scroll-container"
                style={{ overflow: hideOverflow ? 'initial' : 'auto' }}
            >
                {days.map((day, index) => (
                    <div styleName="day" key={`${day[0]?.day}-${index}`}>
                        <div
                            styleName="columns"
                            style={{
                                gridTemplateColumns: `repeat(${
                                    day.length
                                }, ${getColumnWidth()}px)`,
                            }}
                        >
                            {day.map(
                                (item, i) =>
                                    !!item?.item.given_answer && (
                                        <div
                                            styleName={`column ${
                                                weekGoal !== undefined &&
                                                lastItem?.updated_at ===
                                                    item.item.updated_at
                                                    ? 'new-item'
                                                    : ''
                                            }`}
                                            key={`${i}-${item.day}`}
                                            style={{
                                                height: `${
                                                    (100 / peek) *
                                                    parseInt(
                                                        item?.item.given_answer
                                                    )
                                                }%`,
                                            }}
                                        >
                                            {item?.item.given_answer}
                                        </div>
                                    )
                            )}
                        </div>
                        <div
                            styleName="columns goal"
                            style={{
                                gridTemplateColumns: `repeat(${
                                    day.length
                                }, ${getColumnWidth()}px)`,
                            }}
                        >
                            {day.map(
                                (item, i) =>
                                    !!item?.item.correct_answer && (
                                        <div
                                            styleName={`column ${
                                                weekGoal !== undefined &&
                                                lastItem?.updated_at ===
                                                    item.item.updated_at
                                                    ? 'new-item'
                                                    : ''
                                            }`}
                                            key={`${i}-${item.day}`}
                                            style={{
                                                height: `${
                                                    (100 / peek) *
                                                    parseInt(
                                                        item.item.correct_answer
                                                    )
                                                }%`,
                                            }}
                                        />
                                    )
                            )}
                        </div>
                        <p>{day[0]?.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
